<template>
  <div class="SessionsPage">
    <v-container>
      <v-row class="mb-6 mt-4" align="center" justify="start">
        <v-col cols="12" class="pa-0">
          <div class="d-flex flex-column flex-sm-row align-start align-sm-center">
            <v-breadcrumbs :items="crumbs" class="pa-0 mb-3 mb-sm-0" :class="{
              'text-caption': $vuetify.breakpoint.xs,
              'text-body-2': $vuetify.breakpoint.smAndUp
            }"></v-breadcrumbs>

            <div class="d-flex align-center ml-sm-6">
              <v-icon left color="primary" size="24" class="mr-3">
                mdi-forum-outline
              </v-icon>
              <h1 class="text-h5 font-weight-medium ma-0" :class="{
                'text-h6': $vuetify.breakpoint.xs,
                'text-h5': $vuetify.breakpoint.smAndUp
              }">
                Your recent chats
              </h1>
            </div>
          </div>
        </v-col>
      </v-row>

      <chat-session-list :sessions="sessions" :loading="sessionsListLoading" :show-load-more="canLoadMoreSession"
        @load-more="loadMoreSessions" />
    </v-container>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters: customerGetters } = createNamespacedHelpers('customer');
const {
  mapGetters: AIChatGetters,
  mapActions: AIChatActions,
  mapMutations: AIChatMutations,
} = createNamespacedHelpers('AIChat');

import constants from '@/util/constants';
import * as moment from 'moment/moment';
import ChatSessionList from '../../components/chat-session-list.vue';

export default {
  name: 'SessionsPage',
  components: {
    ChatSessionList,
  },
  data() {
    return {
      sessionPage: 0,
      publicPath: constants.isDevelopment ? '' : '',
      canLoadMoreSession: true,
      crumbs: [
        {
          text: 'Chat',
          href: '/start-chat',
          disabled: false,
        },
        {
          text: 'Sessions',
          disabled: true,
          href: '/chat-sessions',
        },
      ],
    };
  },
  computed: {
    ...customerGetters({
      customer: 'CUSTOMER',
      selectedCustomer: 'SELECTED_CUSTOMER',
    }),
    ...AIChatGetters({
      sendMessageLoading: 'SEND_MESSAGE_LOADING',
      sessions: 'SESSIONS_LIST',
      sessionsListLoading: 'SESSIONS_LIST_LOADING',
    }),
  },
  methods: {
    ...AIChatActions(['sendMessage', 'getSessions']),
    ...AIChatMutations({
      setSessions: 'SET_SESSIONS_LIST',
    }),
    getTime(date) {
      return moment(date).fromNow();
    },
    async loadMoreSessions() {
      this.sessionPage += 1;
      const preLoadCount = this.sessions.length;
      await this.getSessions({ page: this.sessionPage, push: true });
      const postLoad = this.sessions.length;
      if (postLoad === preLoadCount) {
        this.canLoadMoreSession = false;
      }
    },
    async getInfo() {
      await this.getSessions({ page: this.sessionPage });
    },
  },
  watch: {
    async 'selectedCustomer.customer_id'() {
      this.setSessions([]);
      await this.getInfo();
    },
  },
  async mounted() {
    await this.getInfo();
  },
};
</script>
